export default customElements.define('w-positional-indicator', class PositionalIndicator extends wealthify.CustomElementBaseClass {

    #positionElements = [];
    #lastValue = 0;

    constructor () {
        const styleSelector = 'c-positional-indicator';
        const config = {
            styleSelector,
            templateHTML: `
                <div class="${styleSelector}__container" aria-hidden="true" data-root>
                    <p class="${styleSelector}__label" data-label></p>
                    <div data-positions></div>
                    <template data-positiontemplate>
                        <div class="${styleSelector}__position"></div>
                    </template>
                </div>`,
            cacheDom: [ 'data-label', 'data-positions', 'data-positiontemplate' ]
        };

        super(config);

        this.onConnectedCallback = () => {  
            this.classList.add(this.styleSelector);
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('label', {required: true}),
            new wealthify.Prop('current', {
                default: 0,
                required: true,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('positions', {type:wealthify.propTypes.Array()}),
            new wealthify.Prop('enlarged', {
                default: false,
                type: wealthify.propTypes.Boolean()
            })
        ];
    }

    get propCallbacks() {
        return {
            label: () => {
                this.dom.label.innerHTML = this.label;    
            },
            current: () => this.#current = this.current,
            positions: () => {
                const fragment = document.createDocumentFragment();

                this.positions.forEach((position, index) => {
                    const positionElement = this.dom.positiontemplate.content.firstElementChild.cloneNode(true);

                    this.#positionElements[index] = positionElement;
                    fragment.appendChild(positionElement);
                });
                
                this.dom.positions.appendChild(fragment);
                this.#current = this.current;
            },
            enlarged: () => {
                const classListAction = this.enlarged ? 'add' : 'remove';

                this.dom.root.classList[classListAction](`${this.styleSelector}--enlarged`);
            }
        };
    }

    get values () {
        return {
            previous: this.positions[this.current - 1] ?? null,
            current: this.positions[this.current],
            next: this.positions[this.current + 1] ?? null
        };
    }

    get #bounds () {
        return {
            min: 0,
            max: this.positions.length - 1
        };
    }

    decrease () {
        if (this.values.previous === null) {
            return false;
        }

        this.current--;
    }

    increase () {
        if (this.values.next === null) {
            return false;
        }

        this.current++;
    }

    set #current (value) {
        const isUndefinedPositions = this.#positionElements.length === 0 || !this.positions;

        if (isUndefinedPositions) {
            return;
        }

        const isOutOfBounds = value < this.#bounds.min || value > this.#bounds.max;

        if (isOutOfBounds) {
            this.current = this.#lastValue;

            return;
        }

        const currentPositionClass = `${this.styleSelector}__position--current`;

        this.#positionElements.forEach((position) => position.classList.remove(currentPositionClass));
        this.#positionElements[value].classList.add(currentPositionClass);
        this.#lastValue = value;
    }

});